import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import SearchIcon from "@material-ui/icons/Search";
import { useStyles } from "./SearchButton.styles";

interface SearchButtonProps {
  loading: boolean;
}

export function SearchButton({ loading }: SearchButtonProps) {
  const classes = useStyles();
  return (
    <Grid container spacing={2} direction={"row"}>
      <Grid item lg={1} md={1} sm={3} xs={6}>
        <Button
          className={classes.button}
          color={"primary"}
          variant={"contained"}
          endIcon={<SearchIcon />}
          type="submit"
          disabled={loading}
        >
          Поиск
        </Button>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          visibility: loading ? "visible" : "hidden",
        }}
      >
        <LinearProgress />
      </Grid>
    </Grid>
  );
}
